"use client";

import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import Container from "@/components/ui/layout/container";
import Section from "@/components/ui/layout/section";
import {
  TypographyH2,
  TypographyH3,
  TypographySmall,
} from "@/components/ui/typography";
import { cls } from "@/lib/utils";
import type { FloorPlanName } from "../../../types";
import { FLOOR_PLANS_DETAILS } from "../../../ui/FloorPlansList/consts";

const SECTION_ID = "project-details";

interface DetailsSectionProperties {
  floorPlanName: FloorPlanName;
}

function DetailsSection({ floorPlanName }: DetailsSectionProperties) {
  const { floors, bedrooms, bathrooms, sqft } =
    FLOOR_PLANS_DETAILS[floorPlanName];

  return (
    <Section id={SECTION_ID}>
      <Container id={SECTION_ID} maxWidth="max-w-5xl">
        <Card variant="secondary">
          <CardHeader className={cls`justify-center items-center text-center`}>
            <TypographyH3>DETAILS</TypographyH3>
            <TypographyH2 className="border-b-0">{floorPlanName}</TypographyH2>
          </CardHeader>

          <CardContent
            className={cls`flex flex-wrap justify-center items-center gap-2 md:gap-4 lg:gap-6`}
          >
            <TypographySmall className={cls`text-center`}>
              {floors} Floors
            </TypographySmall>
            <TypographySmall className={cls`text-center`}>
              {bedrooms} Bedrooms
            </TypographySmall>
            <TypographySmall className={cls`text-center`}>
              {bathrooms} Bathrooms
            </TypographySmall>
            <TypographySmall className={cls`text-center`}>
              {sqft} Sq. Ft.
            </TypographySmall>
          </CardContent>
        </Card>
      </Container>
    </Section>
  );
}

export default DetailsSection;
